// Explicit development preview; never substitutes for a failed API request.
export const isHelpDesignPreview = (id, search, environment) =>
  environment === "development" &&
  id === "sample" &&
  new URLSearchParams(search).get("preview") === "1";
export const sampleHelpCategories = [
  "عیب یابی",
  "پژوهیار آنلاین",
  "پشتیبانی",
  "راهنمای سایت",
  "فیلم آموزشی",
  "نصب و فعال‌سازی پژوهیار",
  "افزونه پژوهیار در Word",
  "محصولات برخط پژوهیار",
  "قاب پژوهیار",
].map((title, index) => ({ id: index + 1, title }));
// Public text from the user-provided help page, kept unchanged for visual QA.
export const sampleHelp = {
  id: "sample",
  title: "نوار ابزار عملیات روی منابع",
  category: sampleHelpCategories[1],
  body: `<p dir="rtl">این نوار ابزار امکانات مختلفی را برای مدیریت منابع در اختیار کاربران قرار می‌دهد. بسته به امکانات فعال سامانه، عملیات زیر از طریق این بخش قابل انجام است:</p>
  <ul dir="rtl">
    <li>افزودن منبع جدید</li><li>ویرایش اطلاعات منبع</li><li>حذف منبع</li><li>استناددهی</li><li>درون‌برد منابع</li><li>صدور منابع</li><li>انتقال منابع بین پوشه‌ها</li><li>اجرای سایر عملیات مدیریتی روی منابع انتخاب‌شده</li>
  </ul>
  <p dir="rtl">این ساختار به کاربران کمک می‌کند تا منابع پژوهشی خود را به‌صورت منظم مدیریت کرده و به‌سرعت به اطلاعات موردنیاز دسترسی داشته باشند.</p>`,
};
